import React, { useRef } from "react";
import { useUserModel } from "../userModel";
import { YHDrawer } from "@components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@components/YhFormBox/Types";
import { YhForm } from "@components/YhFormBox";
import { globalPrompt } from "@src/components/YhMessage";
import { userService } from "../UserService";
import { IResetPwd } from "../UserTypes";


export function PwdDrawer() {
    const {
        pwdVisible,
        setPwdVisible,
        selectedRow,
        editType,
        loadData,
    } = useUserModel();


    const onCancel = () => {
        setPwdVisible(false);
    }

    const formRef = useRef<IYhFormRef>();

    const formConfig: IYhForm = {
        formRef,
        labelCol: { span: 6 },
        disabled: editType === 'look',
        initialValues: selectedRow,
        justify: 'start',
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "用户账号",
                fieldName: "name",
                disable: true,
                span: 24,
            }, {
                type: FormItemTypeEnum.Password,
                fieldLabel: "原始密码",
                fieldName: "pwd",
                disable: true,
                span: 24,
            }, {
                type: FormItemTypeEnum.Password,
                fieldLabel: "新密码",
                fieldName: "newPwd",
                rules: [
                    { required: true, message: "新密码为必填项！" }
                ],
                span: 24,
            }, {
                type: FormItemTypeEnum.Password,
                fieldLabel: "确认密码",
                fieldName: "repeatNewPwd",
                rules: [
                    { required: true, message: "新密码为必填项！" },
                    {
                        validator: (rule, value, callback) => {
                            try {
                                let formData = formRef.current?.getFieldsValue()
                                if (formData.newPwd === value) {
                                    return callback()
                                } else {
                                    return callback("确认密码需要与新密码一致！")
                                }
                            } catch (error) {
                                return callback(error as any)
                            }
                        }
                    }
                ],
                span: 24,
            }
        ]
    };

    const onOk = async () => {
        try {
            const formData = await formRef.current?.validateFields();
            if (formData) {
                const params: IResetPwd = {
                    newPwd: formData.newPwd,
                    originalPwd: selectedRow?.pwd,
                    repeatNewPwd: formData.repeatNewPwd,
                    userCode: selectedRow?.code,
                    resetType: "ADMIN_RESET",
                }
                const insertRet = await userService.updateUserPwd(params);
                if (insertRet.success) {
                    await globalPrompt("message", { type: "success", text: '修改成功!' });
                    onCancel()
                    loadData({ pageNum: 1 }).then()
                } else {
                    await globalPrompt("message", { type: "error", text: "修改失败!" + insertRet.retMsg });
                }

            }
        } catch (e) {
            console.log("失败!");
        }
    }
    const onReset = async () => {
        try {
            const params: IResetPwd = {
                userCode: selectedRow?.code,
                resetType: "ADMIN_RESET",
            }
            const insertRet = await userService.resetUserPwd(params);
            if (insertRet.success) {
                await globalPrompt("message", { type: "success", text: '修改成功!' });
                onCancel()
                loadData({ pageNum: 1 }).then()
            } else {
                await globalPrompt("message", { type: "error", text: "修改失败!" + insertRet.retMsg });
            }
        } catch (e) {
            console.log("失败!");
        }
    }
    return (
        <YHDrawer
            {...{
                title: "修改用户密码",
                visible: pwdVisible,
                onOk,
                onCancel,
                // width: 800,
                showFooter: true,
                okText: '保存',
                cancelText: '取消',
                footerButs: [{
                    text: '重置',
                    onClick: onReset
                }]
            }}
        >
            <YhForm  {...formConfig} />
        </YHDrawer>
    )
}
